import { useMemo } from "react";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";

// TODO: This should not be a hook. It deserves to be in shared-domain/analyses filterByPeriod or something.
const useAnalysesPeriod = (
  aggregationInterval: {
    from: Date;
    to: Date;
  },
  activeAnalyses: ActiveAnalysis[],
) => {
  const from = aggregationInterval.from.getTime();
  const to = aggregationInterval.to.getTime();
  const activeAnalysesPeriod = useMemo(
    () => activeAnalyses.filter(a => a.date >= from && a.date <= to),
    [activeAnalyses, from, to],
  );

  return { activeAnalysesPeriod };
};

export const useActiveAnalysesPeriod = (
  aggregationPeriod: {
    from: Date;
    to: Date;
  },
  activeAnalyses: ActiveAnalysis[],
) => {
  const from = aggregationPeriod.from.getTime();
  const to = aggregationPeriod.to.getTime();
  const activeAnalysesPeriod = useMemo(
    () => activeAnalyses.filter(a => a.date >= from && a.date <= to),
    [activeAnalyses, from, to],
  );

  return { activeAnalysesPeriod };
};

export default useAnalysesPeriod;
